function normalizePurchaseOrderMapGroupId(groupId) {
    if (groupId == null || groupId === '') {
        return null;
    }

    return String(groupId);
}

function combineGroupedPartialPoItems(items) {
    return items.reduce((acc, item) => {
        const groupId = normalizePurchaseOrderMapGroupId(item.purchaseOrderMapGroupId);

        if (groupId == null) {
            acc.push({
                ...item,
                additionalPoMapIds: [],
            });
            return acc;
        }

        const existingItem = acc.find((i) => normalizePurchaseOrderMapGroupId(i.purchaseOrderMapGroupId) === groupId);
        if (existingItem) {
            existingItem.qty += item.qty;
            existingItem.additionalPoMapIds.push(item.poMapID);
        } else {
            acc.push({
                ...item,
                additionalPoMapIds: [],
            });
        }
        return acc;
    }, []);
}

function expandPartialPoItemMapIds(selectedItems) {
    return selectedItems.flatMap((item) => [...(item.additionalPoMapIds || []), item.poMapID]);
}

export { combineGroupedPartialPoItems, expandPartialPoItemMapIds };
